export const DEFAULT_NOTE_EXTENSION = '.md';
export const VALID_NOTE_EXTENSIONS_SET = new Set([DEFAULT_NOTE_EXTENSION]);
export const VALID_MARKDOWN_EXTENSIONS_SET = new Set(['.md', '.markdown']);
export const PATH_SEPARATOR = '/';
